// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cv2-list-row-outer {
  box-sizing: border-box;
  width: 100%;
  padding: 0 8px;
  overflow: visible !important;
}

.cv2-list-row {
  all: unset;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 104px;
  max-height: 104px;
  padding: 16px 8px 16px 16px;
  border-radius: 0;
  cursor: pointer;
  background: transparent;
  border-left: 2px solid transparent;
  overflow: visible !important;
}

.cv2-list-row:hover {
  background: #f9fafa;
  border-radius: 8px;
}

.cv2-list-row--active {
  background: #f3fbff !important;
  /* border-left-color: #148dfd; */
  border-radius: 0;
  margin: 0 -8px;
  width: calc(100% + 16px);
  padding-left: 24px;
  padding-right: 16px;
}

.cv2-list-row--ended {
  opacity: 0.8;
}

.cv2-list-row__avatar {
  position: relative;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  overflow: visible !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.cv2-list-row__avatar .MuiAvatar-root {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  min-height: 32px !important;
  margin: 0 !important;
  border-radius: 50% !important;
  overflow: hidden !important;
  flex-shrink: 0;
  box-sizing: border-box;
}

.cv2-list-row__avatar .MuiAvatar-root .MuiAvatar-img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.cv2-list-row__status {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1.5px solid #fff;
  box-sizing: border-box;
  z-index: 2;
  pointer-events: none;
}

.cv2-list-row__status.is-online {
  background: #389e0d;
}

.cv2-list-row__status.is-offline {
  background: #a5b2bd;
}

.cv2-list-row__unread {
  flex-shrink: 0;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #ff4d4f;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
}

.cv2-list-row__tick {
  flex-shrink: 0;
  width: 14px;
  height: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.cv2-list-row__tick svg {
  width: 14px;
  height: 8px;
  display: block;
}

.chatv2-list-column .ChatBar-SearchInput {
  display: none !important;
}

.chatv2-list-column .ChatUser-Main-Container--virtualized,
.chatv2-list-column .ChatUser-Main-Container {
  height: 100% !important;
  max-height: none !important;
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/ChatV2/chatListRowV2.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB","sourcesContent":[".cv2-list-row-outer {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 8px;\n  overflow: visible !important;\n}\n\n.cv2-list-row {\n  all: unset;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n  min-height: 104px;\n  max-height: 104px;\n  padding: 16px 8px 16px 16px;\n  border-radius: 0;\n  cursor: pointer;\n  background: transparent;\n  border-left: 2px solid transparent;\n  overflow: visible !important;\n}\n\n.cv2-list-row:hover {\n  background: #f9fafa;\n  border-radius: 8px;\n}\n\n.cv2-list-row--active {\n  background: #f3fbff !important;\n  /* border-left-color: #148dfd; */\n  border-radius: 0;\n  margin: 0 -8px;\n  width: calc(100% + 16px);\n  padding-left: 24px;\n  padding-right: 16px;\n}\n\n.cv2-list-row--ended {\n  opacity: 0.8;\n}\n\n.cv2-list-row__avatar {\n  position: relative;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  overflow: visible !important;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.cv2-list-row__avatar .MuiAvatar-root {\n  width: 32px !important;\n  height: 32px !important;\n  min-width: 32px !important;\n  min-height: 32px !important;\n  margin: 0 !important;\n  border-radius: 50% !important;\n  overflow: hidden !important;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.cv2-list-row__avatar .MuiAvatar-root .MuiAvatar-img {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n}\n\n.cv2-list-row__status {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 1.5px solid #fff;\n  box-sizing: border-box;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.cv2-list-row__status.is-online {\n  background: #389e0d;\n}\n\n.cv2-list-row__status.is-offline {\n  background: #a5b2bd;\n}\n\n.cv2-list-row__unread {\n  flex-shrink: 0;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 8px;\n  background: #ff4d4f;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 16px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.cv2-list-row__tick {\n  flex-shrink: 0;\n  width: 14px;\n  height: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n}\n\n.cv2-list-row__tick svg {\n  width: 14px;\n  height: 8px;\n  display: block;\n}\n\n.chatv2-list-column .ChatBar-SearchInput {\n  display: none !important;\n}\n\n.chatv2-list-column .ChatUser-Main-Container--virtualized,\n.chatv2-list-column .ChatUser-Main-Container {\n  height: 100% !important;\n  max-height: none !important;\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
